import { create } from 'zustand';
import { ApiUtils, CardApi, type CardEntity, type StoreBaseReturn } from '@shared/api';

interface UseReprintCardStore {
  loading: boolean;
  card: CardEntity[];
  error: string | null;
  reprintPin: (accountId: string, signal?: AbortSignal) => Promise<StoreBaseReturn<CardEntity[]>>;
  clear: () => void;
}

export const useReprintCardStore = create<UseReprintCardStore>((set) => ({
  loading: false,
  card: [],
  error: null,

  reprintPin: async (accountId, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await CardApi.reprintPin(accountId, signal);
      set({ loading: false, card: result || [] });
      return { loading: false, data: result || [], error: null };
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
      return { loading: false, data: [], error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ loading: false, card: [], error: null }),
}));
